import React, { useContext, useRef } from 'react';

import { useDay } from '@datepicker-react/hooks';
import classNames from 'classnames';
import { isToday } from 'date-fns';

import DatepickerContext from '../datepicker-context';

import './datepicker-day.scss';

interface DatepickerDayProps {
  dayLabel: string;
  date: Date;
}

const DatepickerDay: React.FC<DatepickerDayProps> = ({ dayLabel, date }) => {
  const dayRef = useRef<HTMLButtonElement>(null);
  const {
    focusedDate,
    isDateFocused,
    isDateSelected,
    isDateHovered,
    isDateBlocked,
    isFirstOrLastSelectedDate,
    onDateSelect,
    onDateFocus,
    onDateHover,
  } = useContext(DatepickerContext);
  const {
    isSelectedStartOrEnd,
    isSelected,
    isWithinHoverRange,
    disabledDate,
    onClick,
    onKeyDown,
    onMouseEnter,
    tabIndex,
  } = useDay({
    date,
    focusedDate,
    isDateFocused,
    isDateSelected,
    isDateHovered,
    isDateBlocked,
    isFirstOrLastSelectedDate,
    onDateFocus,
    onDateSelect,
    onDateHover,
    dayRef,
  });

  if (!dayLabel) {
    return <div />;
  }

  return (
    <button
      className={classNames('datepicker-day', {
        'datepicker-day--current': isToday(date),
        'datepicker-day--disabled': disabledDate,
        'datepicker-day--selected': isSelected || isSelectedStartOrEnd,
        'datepicker-day--hover': isWithinHoverRange,
      })}
      onClick={onClick}
      onKeyDown={onKeyDown}
      onMouseEnter={onMouseEnter}
      type="button"
      tabIndex={tabIndex}
      ref={dayRef}
    >
      {dayLabel}
    </button>
  );
};

export default DatepickerDay;
